/**
 * Public SSM API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0-private
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { CommandHandlerResponse } from '../model/commandHandlerResponse';
import { InsuranceClaimingBranchConfigDto } from '../model/insuranceClaimingBranchConfigDto';
import { InsuranceClaimingStatusListDto } from '../model/insuranceClaimingStatusListDto';
import { RepairEstimateUrlResponse } from '../model/repairEstimateUrlResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RepairEstimateSessionViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * AmsAction:GET/api/RepairEstimateSessionView/{sessionId}/SessionUrl AmsOptionalAction:MakeValuationWithoutVIN AmsOptionalAction:MakeValuationWithoutNumberPlate AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/RepairEstimateSessionView/{sessionId} 
     * @param sessionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sessionUrl(sessionId: string, observe?: 'body', reportProgress?: boolean): Observable<RepairEstimateUrlResponse>;
    public sessionUrl(sessionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RepairEstimateUrlResponse>>;
    public sessionUrl(sessionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RepairEstimateUrlResponse>>;
    public sessionUrl(sessionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling sessionUrl.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RepairEstimateUrlResponse>(`${this.basePath}/api/RepairEstimateSessionView/${encodeURIComponent(String(sessionId))}/SessionUrl`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:GET/api/RepairEstimateSessionView/Case/{caseId}/VehicleInsuranceClaimingBranchConfig AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/RepairEstimateSessionView/Case/{caseId}/VehicleInsuranceClaimingBranchConfig 
     * @param caseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vehicleInsuranceClaimingBranchConfig(caseId: string, observe?: 'body', reportProgress?: boolean): Observable<InsuranceClaimingBranchConfigDto>;
    public vehicleInsuranceClaimingBranchConfig(caseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InsuranceClaimingBranchConfigDto>>;
    public vehicleInsuranceClaimingBranchConfig(caseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InsuranceClaimingBranchConfigDto>>;
    public vehicleInsuranceClaimingBranchConfig(caseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling vehicleInsuranceClaimingBranchConfig.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<InsuranceClaimingBranchConfigDto>(`${this.basePath}/api/RepairEstimateSessionView/Case/${encodeURIComponent(String(caseId))}/VehicleInsuranceClaimingBranchConfig`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:GET/api/RepairEstimateSessionView/Case/{caseId}/VehicleInsuranceClaimingStatus AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/RepairEstimateSessionView/Case/{caseId}/VehicleInsuranceClaimingStatus 
     * @param caseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vehicleInsuranceClaimingStatus(caseId: string, observe?: 'body', reportProgress?: boolean): Observable<InsuranceClaimingStatusListDto>;
    public vehicleInsuranceClaimingStatus(caseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InsuranceClaimingStatusListDto>>;
    public vehicleInsuranceClaimingStatus(caseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InsuranceClaimingStatusListDto>>;
    public vehicleInsuranceClaimingStatus(caseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling vehicleInsuranceClaimingStatus.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<InsuranceClaimingStatusListDto>(`${this.basePath}/api/RepairEstimateSessionView/Case/${encodeURIComponent(String(caseId))}/VehicleInsuranceClaimingStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
